<template>
    <div class="flex flex-col gap-6">
        <h2 class="text-2xl md:text-4xl font-semibold text-darkerblue">Genetic Test Results</h2>

        <div>
            <h3 class="text-base md:text-2xl font-semibold mb-3">Genetic test results<sup>1</sup></h3>

            <ul class="list-disc pl-4 font-light">
                <li>PCR and direct sequencing was performed</li>
                <li>
                    Molecular analysis showed that the patient had a homozygous frameshift deletion at c.33delC;
                    p.(Lys12Argfs*34) in exon 1 of the <span class="italic text-lightblue">AGXT</span> gene
                </li>
                <li>
                    The molecular analysis was performed for the patient, both of her parents, and her elder brother and
                    younger sister
                    <ul class="list-inside list-['-_'] pl-4 font-light">
                        <li>Testing of both of her parents identified heterozygous deletions at a similar position</li>
                    </ul>
                </li>
                <li>
                    Literature recommends to offer genetic counseling to patients with PH and their families<sup>2</sup>
                </li>
            </ul>
        </div>

        <h2 class="text-2xl md:text-3xl font-semibold text-center">
            Algorithm for Diagnostic Evaluation of PH – Genetic Testing<sup>2–4</sup>
        </h2>

        <img
            src="@/assets/img/graphics/pediatric/genetic-testing-desktop.svg"
            alt="Genetic Testing"
            class="hidden sm:block"
        />
        <img src="@/assets/img/graphics/pediatric/genetic-testing-mobile.svg" alt="Genetic Testing" class="sm:hidden" />

        <h3 class="text-base md:text-2xl font-semibold mb-3 p-6 bg-lightblue50 text-center">
            Confirmation of PH1?<sup>1</sup> Yes
        </h3>
    </div>
</template>
